import { Environment, getEnvironment } from '@backoffice-frontend/environment'
import { setUpTOTP } from 'aws-amplify/auth'
import { useEffect, useState } from 'react'

export const useAuthQrCode = () => {
  const [qrCodeUrl, setQrCodeUrl] = useState('')
  const [code, setCode] = useState('')

  useEffect(() => {
    const getEnv = () => {
      switch (getEnvironment()) {
        case Environment.development:
          return '[DEV]'
        case Environment.integration:
          return '[INT]'
        default:
          return ''
      }
    }

    setUpTOTP().then(result => {
      setCode(result.sharedSecret)
      setQrCodeUrl(
        result.getSetupUri(`${getEnv()}MOIA-Backoffice-Frontend`).href,
      )
    })
  }, [])

  return { code, qrCodeUrl }
}
